import type { SeamEvent } from "@seamapi/http"
import { useQuery } from "@tanstack/react-query"
import { useSeamHttpClient } from "."

export const useEvent = (opts: {
  workspace_id?: string | null
  event_id?: string | null
}) => {
  const { workspace_id, event_id } = opts
  const seam = useSeamHttpClient(workspace_id!)
  return useQuery({
    queryKey: ["events", workspace_id, event_id],
    queryFn: async () => await seam.events.get({ event_id: event_id ?? "" }),
    enabled: Boolean(seam && workspace_id && event_id),
  })
}
